<div class="card one-cart-section primary-border">
  <div class="card-block" *ngIf="resa.formation">
    <h3>
      <b>{{ resa.formation.libelle }}</b>
    </h3>
    <p>{{ resa.formation.focus.accroche }}</p>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <ng-container *ngIf="resa.session_list && resa.session_list.length; else noSessionForThisResa">
            <kendo-dropdownlist
              class="one-cart-combo"
              [data]="resa.session_list"
              [textField]="'ref'"
              [valueField]="'id'"
              [(value)]="resa.selected_session"
              (valueChange)="saveSelection(resa)"
            >
              <ng-template kendoDropDownListValueTemplate let-dataItem>
                {{ getComboLineTemplate(dataItem, resa) }}
              </ng-template>
              <ng-template kendoDropDownListItemTemplate let-dataItem>
                {{ getComboLineTemplate(dataItem, resa) }}
              </ng-template>
            </kendo-dropdownlist>
            <button
              #anchor
              kendoButton
              class="colored-text"
              *ngIf="resa.selected_session"
              (click)="orderValidation(resa)"
            >
              S'inscrire
            </button>
          </ng-container>
          <ng-template #noSessionForThisResa>
            Aucune session disponible
          </ng-template>
        </div>
      </div>
    </div>
    <div class="card-block" *ngIf="!resa.formation">
      Aucune formation disponible
    </div>
    <button
      kendoButton
      class="corner-tr"
      [icon]="'close'"
      [primary]="true"
      [look]="'flat'"
      (click)="removeResa()"
    ></button>
  </div>

  <!-- [(value)]="resa.selected_session" -->
</div>
